import { EnrollmentProposition } from '../../lib/types/models/enrollment-proposition/enrollment-proposition'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getEnrollmentProposition(input: {
  enrollmentId: number
  propositionId: number
}): Promise<EnrollmentProposition> {
  return restApiClient
    .url(
      constructApiUrl(API.enrollments.getProposition.url, {
        id: input.enrollmentId,
        propositionId: input.propositionId
      })
    )
    .get<EnrollmentProposition>()
}
